<template>
  <div class="form-group" :id="id + '-limit'" data-trigger="hover">
    <div class="input-group">
      <b-form-input
        v-model="simpleLimit"
        placeholder="Limit"
        type="number"
        min="0"
        aria-describedby="basic-addon2"
        :disabled="currentUser.id !== 1"
      ></b-form-input>
      <b-tooltip :target="id + '-limit'" triggers="hover">Limit</b-tooltip>
      <div class="input-group-append" v-if="params.value_type === 'percent'">
        <span class="input-group-text"
          ><i class="la la-percent icon-lg"></i
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    params: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser"]),
    simpleLimit: {
      get() {
        return this.params.limit;
      },
      set(newValue) {
        this.params.limit = Math.abs(parseInt(newValue));
        this.$emit("change");
      }
    }
  }
};
</script>

<style scoped>
.left-padding {
  padding-left: 20px;
}
</style>
